export default __webpack_public_path__ + "/dist/images/no-data.f8b11d6a0d3229544cc6860a5333f1a0.svg";